/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Meta_DescInputs */

const en_wc_vs_meta_desc = /** @type {(inputs: Wc_Vs_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft vs Microsoft Word compared honestly: price, license, platforms, .docx compatibility, offline use, AI features, collaboration and maturity of ArtCraft WordCraft.`)
};

/**
* | output |
* | --- |
* | "WordCraft vs Microsoft Word compared honestly: price, license, platforms, .docx compatibility, offline use, AI features, collaboration and maturity of ArtCra..." |
*
* @param {Wc_Vs_Meta_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_meta_desc = /** @type {((inputs?: Wc_Vs_Meta_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Meta_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_meta_desc(inputs)
});
export { wc_vs_meta_desc as "wc.vs.meta_desc" }